import React from 'react';

const QuestionnaireSystem = () => {
  return (
    <div className="container-fluid">
      <div className="page-title">
        <div>
          <h3>Questionnaire System</h3>
          <span>Manage questionnaires and patient responses</span>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h5 className="card-title mb-0">Questionnaires</h5>
            </div>
            <div className="card-body">
              <p>Questionnaire system functionality will be implemented here.</p>
              <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                <button className="btn btn-primary">Create New Questionnaire</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionnaireSystem;
